





'use strict';





var helpers = {

  textarea: function(data) {
    var requiredAttrs = ["id"],
      reservedAttrs = ["type","data-mask","data-gis-mask"],
      combinableAttrs = {"class": "spa-input-textarea", "value": ""},
      attrsStr,
      optionsString="",
      output;

    if(!Handlebars.helpers.requiredAttrsCheck(data.textarea.attrs,requiredAttrs).pass) {


        throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.textarea.attrs,requiredAttrs).missingField);


        if(window.console && console.log) {
          console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.textarea.attrs,requiredAttrs).missingField);
          return "";
        }
    }
    Handlebars.helpers.removeReservedAttrs(data.textarea.attrs,reservedAttrs);
    Handlebars.helpers.combineAttrs(data.textarea.attrs,combinableAttrs);
    attrsStr = Handlebars.helpers.buildAttrsString(data.textarea.attrs);

    output = '<div class="spa-input spa-input-box spa-input--'+((data.skin) ? data.skin : 'material-design')+' '+((data.containerClasses) ? data.containerClasses.join(' ') : '')+'"> \
              <label class="spa-input-label" for="'+data.textarea.attrs.id+'">'+data.label.text+'<span class="ada-hidden"> '+((data.label.adaText) ? data.label.adaText : '')+'</span></label> \
              <textarea '+attrsStr+' '+((data.required) ? 'required' : '' )+'>'+((data.textarea.attrs.value !== undefined) ? data.textarea.attrs.value : '')+'</textarea> \
              <p class="spa-input-hint">'+((data.hintText) ? data.hintText : '')+'</p> \
            </div>';

    return new Handlebars.SafeString(output);
  }
};



module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};


module.exports.helpers = helpers;
